import { Helper } from '../Helpers/helper';
import { Component, ElementRef, Input, HostListener } from '@angular/core';
declare var googleLoaded: any;

@Component({ standalone: false, selector: 'visiba-google-chart', host: { '[id]': 'id' }, template: '' })
export class VisibaGoogleChart {
	@Input() type: string;
	@Input() options: any = {};
	@Input() data: any;

	id: string = 'vbla';
	yes: boolean = true;

	constructor(
		public _elementRef: ElementRef,
		private helper: Helper,
	) {
		this.id = Math.random().toString(36).substring(3);
	}

	ngAfterViewInit() {
		this.init();
	}

	init() {
		if (typeof google === 'undefined' || !google.charts) {
			window.setTimeout(() => {
				this.init();
			}, 1000);
			return;
		}

		google.charts.load('current', { packages: ['corechart'] });
		google.charts.setOnLoadCallback(() => {
			this.draw();
		});
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.draw();
	}

	draw = () => {
		if (typeof this.data === 'undefined' || this.data === null || this.data === '' || this.data.length === 0) return;

		if (!google.visualization || !google.visualization.ChartWrapper) {
			window.setTimeout(this.draw, 500);
			return;
		}

		let options = this.defaultOptions();
		this.helper.object.merge(options, this.options);

		if (typeof this.options['extraWidth'] === 'number') {
			options['width'] += this.options['extraWidth'];
		}
		new google.visualization.ChartWrapper({
			chartType: this.type,
			dataTable: this.data,
			options: options,
			containerId: this.id,
		}).draw();
	};

	defaultOptions(): Object {
		let opt: any = {
			width: this._elementRef.nativeElement.parentNode.clientWidth,
			chartArea: { width: '85%', height: '65%' },
			legend: { position: 'bottom', alignment: 'end' },
			colors: ['008296'],
		};
		return opt;
	}
}
